/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Post_Purchase_Android_AppInputs */

const en_post_purchase_android_app = /** @type {(inputs: Post_Purchase_Android_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android App`)
};

const es_post_purchase_android_app = /** @type {(inputs: Post_Purchase_Android_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App de Android`)
};

/**
* | output |
* | --- |
* | "Android App" |
*
* @param {Post_Purchase_Android_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const post_purchase_android_app = /** @type {((inputs?: Post_Purchase_Android_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Post_Purchase_Android_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_post_purchase_android_app(inputs)
	return en_post_purchase_android_app(inputs)
});